export default {
  name: 'en',
  sure: {
    icon: 'sure icon locale'
  }
}
